import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M44.7998 40.884C44.7998 43.8195 42.4201 46.1992 39.4846 46.1992L16.5151 46.1992C13.5795 46.1992 11.1998 43.8195 11.1998 40.884L11.1998 5.31448C11.1998 2.37895 13.5795 -0.000777335 16.5151 -0.000777079L39.4846 -0.000775071C42.4201 -0.000774814 44.7998 2.37894 44.7998 5.31448L44.7998 40.884Z",
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.2851 54.2586L7.63073 54.2586C5.15602 54.2586 3.14987 52.2524 3.14987 49.7777L3.14988 12.4444C3.14988 9.9697 5.15603 7.96354 7.63074 7.96354L35.2851 7.96355C37.7598 7.96355 39.7659 9.9697 39.7659 12.4444L39.7659 49.7777C39.7659 52.2524 37.7598 54.2586 35.2851 54.2586Z",
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 36H28",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 32H28",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 28H28",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 40H19.5H25",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 43.303,
			cy: 35.303,
			r: 11.253,
			fill: "white",
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2532 24.4766L43.2532 25.4652",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2532 45.2363L43.2532 46.225",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3668 35.3496L32.8725 35.3496L32.3782 35.3496",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.128 35.3496L53.1394 35.3496",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.2986 31.3945L43.2531 35.3491",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.2077 35.3496L43.2532 35.3496",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4095 22C14.1762 22 13.9962 21.9367 13.8695 21.81C13.7428 21.6833 13.6795 21.5033 13.6795 21.27V15.67C13.6795 15.4367 13.7495 15.25 13.8895 15.11C14.0295 14.97 14.2195 14.9 14.4595 14.9C14.6995 14.9 14.8895 14.97 15.0295 15.11C15.1695 15.25 15.2395 15.4367 15.2395 15.67V20.73H17.7995C18.2862 20.73 18.5295 20.9433 18.5295 21.37C18.5295 21.79 18.2862 22 17.7995 22H14.4095ZM21.4043 16.97C22.1243 16.97 22.6576 17.1467 23.0043 17.5C23.3509 17.8467 23.5243 18.38 23.5243 19.1V21.36C23.5243 21.58 23.4609 21.7533 23.3343 21.88C23.2076 22 23.0309 22.06 22.8043 22.06C22.5909 22.06 22.4176 21.9967 22.2843 21.87C22.1576 21.7367 22.0943 21.5667 22.0943 21.36V21.29C21.9943 21.5367 21.8276 21.73 21.5943 21.87C21.3609 22.01 21.0876 22.08 20.7743 22.08C20.4409 22.08 20.1376 22.0133 19.8643 21.88C19.5976 21.7467 19.3843 21.56 19.2243 21.32C19.0709 21.08 18.9943 20.8133 18.9943 20.52C18.9943 20.16 19.0843 19.8767 19.2643 19.67C19.4509 19.4633 19.7476 19.3133 20.1543 19.22C20.5609 19.1267 21.1176 19.08 21.8243 19.08H22.0843V18.9C22.0843 18.62 22.0209 18.4167 21.8943 18.29C21.7743 18.1633 21.5709 18.1 21.2843 18.1C20.9976 18.1 20.5843 18.2 20.0443 18.4C19.8909 18.4733 19.7609 18.51 19.6543 18.51C19.5076 18.51 19.3909 18.46 19.3043 18.36C19.2176 18.2533 19.1743 18.1167 19.1743 17.95C19.1743 17.8167 19.2043 17.7067 19.2643 17.62C19.3243 17.5333 19.4209 17.4533 19.5543 17.38C19.7876 17.2533 20.0709 17.1533 20.4043 17.08C20.7443 17.0067 21.0776 16.97 21.4043 16.97ZM21.1043 21.04C21.3976 21.04 21.6343 20.9433 21.8143 20.75C21.9943 20.55 22.0843 20.2933 22.0843 19.98V19.81H21.9143C21.3743 19.81 20.9943 19.8533 20.7743 19.94C20.5609 20.0267 20.4543 20.1833 20.4543 20.41C20.4543 20.5967 20.5143 20.75 20.6343 20.87C20.7609 20.9833 20.9176 21.04 21.1043 21.04ZM21.4043 16.5C21.0976 16.5 20.8376 16.3967 20.6243 16.19C20.4176 15.9833 20.3143 15.7267 20.3143 15.42C20.3143 15.12 20.4176 14.8667 20.6243 14.66C20.8376 14.4533 21.0976 14.35 21.4043 14.35C21.7109 14.35 21.9676 14.4533 22.1743 14.66C22.3876 14.8667 22.4943 15.12 22.4943 15.42C22.4943 15.7267 22.3876 15.9833 22.1743 16.19C21.9676 16.3967 21.7109 16.5 21.4043 16.5ZM21.4043 15.88C21.5309 15.88 21.6343 15.8367 21.7143 15.75C21.7943 15.6633 21.8343 15.5533 21.8343 15.42C21.8343 15.2933 21.7943 15.1867 21.7143 15.1C21.6343 15.0133 21.5309 14.97 21.4043 14.97C21.2776 14.97 21.1743 15.0133 21.0943 15.1C21.0143 15.1867 20.9743 15.2933 20.9743 15.42C20.9743 15.5533 21.0143 15.6633 21.0943 15.75C21.1743 15.8367 21.2776 15.88 21.4043 15.88ZM27.7332 16.97C28.3199 16.97 28.7566 17.1433 29.0432 17.49C29.3299 17.83 29.4732 18.3467 29.4732 19.04V21.35C29.4732 21.57 29.4032 21.7433 29.2632 21.87C29.1299 21.9967 28.9466 22.06 28.7132 22.06C28.4799 22.06 28.2966 21.9967 28.1632 21.87C28.0299 21.7433 27.9632 21.57 27.9632 21.35V19.11C27.9632 18.7767 27.8999 18.5333 27.7732 18.38C27.6532 18.2267 27.4632 18.15 27.2032 18.15C26.8899 18.15 26.6366 18.25 26.4432 18.45C26.2566 18.65 26.1632 18.9167 26.1632 19.25V21.35C26.1632 21.57 26.0966 21.7433 25.9632 21.87C25.8299 21.9967 25.6466 22.06 25.4132 22.06C25.1799 22.06 24.9932 21.9967 24.8532 21.87C24.7199 21.7433 24.6532 21.57 24.6532 21.35V17.68C24.6532 17.4733 24.7232 17.3067 24.8632 17.18C25.0099 17.0533 25.1966 16.99 25.4232 16.99C25.6299 16.99 25.7966 17.0533 25.9232 17.18C26.0566 17.3 26.1232 17.4567 26.1232 17.65V17.79C26.2966 17.5233 26.5199 17.32 26.7932 17.18C27.0732 17.04 27.3866 16.97 27.7332 16.97Z",
			fill: "#031839"
		})
	]
});
export default SvgLoan;
